import React from 'react';
import { InstagramIcon, FacebookIcon } from 'lucide-react';
import { Logo } from './Logo';
import { Stars } from './Stars';
import { navLinks } from '../data/partners';
export function Footer() {
  return <footer className="bg-ink text-sand" data-id="element-95" data-mp="32onl753ftsa0">
      <div className="mx-auto grid max-w-7xl gap-10 px-5 py-16 md:px-8 lg:grid-cols-12" data-id="element-96" data-mp="32lrlbb814tix">
        <div className="lg:col-span-5" data-id="element-97" data-mp="36ppihgdsnu9c">
          <div className="inline-block rounded-3xl bg-sand p-4" data-id="element-98" data-mp="3ufa6idot1hph">
            <Logo className="w-40" data-id="element-99" data-mp="3ucxok0j1r7cf" />
          </div>
          <p className="mt-6 max-w-sm text-sand/70" data-id="element-100" data-mp="38zaivynj750">
            Celebrating Our Heritage. Strengthening Our Community. Creating Opportunity.
          </p>
        </div>

        <nav className="lg:col-span-4" aria-label="Footer" data-id="element-101" data-mp="3qdf393nbcu92">
          <h2 className="font-display text-xl uppercase text-sun" data-id="element-102" data-mp="3qbvq3lwyezbi">Explore</h2>
          <ul className="mt-4 grid grid-cols-2 gap-3" data-id="element-103" data-mp="29y5kubu3m50a">
            {navLinks.map(link => <li key={link.href} data-id="element-104" data-mp="2ezba1zojva52">
                <a href={link.href} className="text-sand/80 transition-colors duration-150 hover:text-sun" data-id="element-105" data-mp="2ew6z8jgkxg5f">
                  {link.label}
                </a>
              </li>)}
          </ul>
        </nav>

        <div className="lg:col-span-3" data-id="element-106" data-mp="3v7q5bns72hez">
          <h2 className="font-display text-xl uppercase text-sun" data-id="element-107" data-mp="3v8rgds97n3wp">Follow</h2>
          <div className="mt-4 flex gap-3" data-id="element-108" data-mp="3q83tnis0l98a">
            <a href="https://www.instagram.com/honduransinla/" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="rounded-full border border-sand/20 p-3 transition-colors duration-150 hover:bg-sunset hover:text-ink" data-id="element-109" data-mp="3q727oj9gn2bs">
              <InstagramIcon size={20} data-id="element-110" data-mp="huo3x0lbynsz" />
            </a>
            <a href="#" aria-label="Facebook" className="rounded-full border border-sand/20 p-3 transition-colors duration-150 hover:bg-sunset hover:text-ink" data-id="element-111" data-mp="cv1smwp2bhmt">
              <FacebookIcon size={20} data-id="element-112" data-mp="mthhet0maet5" />
            </a>
          </div>
        </div>
      </div>

      <div className="border-t border-sand/10" data-id="element-113" data-mp="two4vw6mvl8d">
        <div className="mx-auto flex max-w-7xl flex-col gap-3 px-5 py-6 text-sm text-sand/60 md:flex-row md:items-center md:justify-between md:px-8" data-id="element-114" data-mp="ytxzrrcskp3l">
          <p data-id="element-115" data-mp="13rpuet4tmpbh">© {new Date().getFullYear()} Hondurans In LA</p>
          <Stars className="text-sun" size={12} data-id="element-116" data-mp="18kiswz9p51f4" />
        </div>
      </div>
    </footer>;
}